import { Form, Input, Modal } from 'antd';
import React, { FC } from 'react';

import { TitleModal } from '../../../components/TitleModal';
import { FormOrder } from '../FormOrder';
import { Order } from '../Orders.interfaces';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  data: null | Order;
  onGetOrders: () => void;
};

export const ModalActiveOrder: FC<Props> = ({
  isOpen,
  onClose,
  data,
  onGetOrders,
}) => {
  return (
    <Modal
      width={600}
      destroyOnClose
      footer={null}
      onCancel={onClose}
      title={
        <TitleModal>
          Заявка №{data?.number}{' '}
          <span>
            ({data?.orderType}-{data?.assetType})
          </span>
        </TitleModal>
      }
      open={isOpen}
    >
      <FormOrder
        isOpen={isOpen}
        onClose={onClose}
        dataOrder={data ?? undefined}
        onGetOrders={onGetOrders}
      />
    </Modal>
  );
};
